import BaseService from "@/services/BaseService";
import * as URI from "../schemePlanning/constant";

const action = {
  /**
   * api gets the items for dropdown in tnc section
   * for header and footer.
   */
  async fetchTncHeaderFooterOptions({ commit }, payload) {
    let url = "";
    if(payload){
        url = URI.TNC_HEADER_FOOTER_OPTIONS_URL.replace("{division}",payload.division ? payload.division : "")
        .replace("{incentiveAudience}",payload.incentiveAudience ? payload.incentiveAudience : "");
    }
    else {
      url = URI.TNC_HEADER_FOOTER_OPTIONS_URL
    }
    const tncHeaderFooterRes = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setHeaderFooterOptions", tncHeaderFooterRes.data);
    return tncHeaderFooterRes;
  },
  async getHeaderFooterById({ commit }, payload) {
    const url = URI.TNC_HEADER_FOOTER_BY_ID_URL.replace("{id}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);

    return response.data;
  },
  async getSchemesAction({ commit }, payload) {
    let url = URI.SCHEDULE_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const schemes = await BaseService.getSchemePlanningClient().get(url);
    commit("setSchemes", schemes.data.data);
    return schemes.data.data;
  },
  async getGeneralMasterFormDataAction({ commit }, payload) {
    let query = "";
    if(payload) {
      query = `?planNo=${payload}`;
    }
    let url = URI.GENERAL_MASTER_DATA_URI.replace(
      "{payload}", query);
    const generalData = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setGeneralFormData", generalData.data.data);
    return generalData.data;
  },
  async getGeneralFormDataAction({ commit }, payload) {
    const generalData = await BaseService.getSchemePlanningClient().get(
      URI.MASTER_DATA_URI
    );
    commit("setGeneralFormData", generalData.data.data);
    return generalData.data;
  },
  updateCreateschemeForm({ commit }, payload) {
    commit("setCreateschemeForm", payload);
  },
  async getGroupDataListAction({ commit }, payload) {
    const groups = await BaseService.getSchemePlanningClient().get(
      URI.PRODUCT_GROUPS_URL
    );
    commit("setGroups", groups.data.data);
  },
  async fetchPartnerGroups({ commit }, payload) {
    let url = URI.PARTNER_GROUPS_URL.replace(
      "{currentPage}",
      payload.page?.currentPage
    )
      .replace("{pageSize}", payload.page?.pageSize)
      .replace("{value}", payload.sord?.value)
      .replace("{sortOrder}", payload.sord?.__sortOrder);
    const groups = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setPartnerGroups", groups.data.data);
  },
  async getPartnerGroupsList({ commit }, payload) {
    const groups = await BaseService.getSchemePlanningClient().get(
      URI.SMART_SEARCH_PARTNER_GROUP_URL.replace("{search}", payload.searchTerm)
    );
    commit("setPartnerGroups", groups.data.data);
    return groups.data.data;
  },
  async storePartnerGroupIdForDemoDeduction({commit}, payload) {
    commit("setStorePartnerGroupIdForDemoDeduction",payload);
  },
  async fetchProductGroups({ commit }, payload) {
    let url = URI.PRODUCT_ALL_GROUP_URL.replace(
      "{currentPage}",
      payload.page?.currentPage
    )
      .replace("{pageSize}", payload.page?.pageSize)
      .replace("{value}", payload.sord?.value)
      .replace("{sortOrder}", payload.sord?.__sortOrder);
    const groups = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setProductGroups", groups.data.data);
  },
  async getProductGroupsList({ commit }, payload) {
    const groups = await BaseService.getSchemePlanningClient().get(
      URI.SMART_SEARCH_PRODUCT_GROUP_URL.replace("{search}", payload.searchTerm)
    );
    commit("setProductGroups", groups.data.data);
    return groups.data.data;
  },
  async getCreatePartnerDataAction({ commit }, payload) {
    const groups = await BaseService.getSchemePlanningClient().get(
      URI.PARTNER_GROUP_URL
    );

    commit("setCreatePartnerGroupData", groups.data.data);
  },
  async fetchSingleGroupData({ commit }, payload) {
    const url = URI.FETCH_SINGLE_GROUP_URL.replace("{payload}", payload);
    const group = await BaseService.getSchemePlanningClient().get(url);
    commit("setSingleGroupData", group.data.data);
  },
  async fetchViewProductHeirachyData({ commit }, payload) {
    const url = URI.FETCH_VIEWPRODUCT_HEIRACHY_URL.replace(
      "{payload}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },

  async fetchGroupType({ commit }, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.value}`)
      .join("&");
    let pay = `${payload.groupType}?division=${payload.division}&${channelIds}`;
    url = URI.PARTNER_GROUP_BY_TYPE_URL.replace("{payload}", pay);
    const groupTypeDetails = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setGroupTypeDetails", groupTypeDetails.data.data);
    return groupTypeDetails.data.data;
  },
  async saveNewGroupData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_NEW_PARTNER_URL,
      payload
    );
    return response;
  },
  async saveProductGroupData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_NEW_PRODUCT_GROUP_URL,
      payload
    );
    return response.data;
  },
  async saveSpecificGroupData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.UPDATE_PARTNER_URL,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async validatePartnerExcludeIncludeCodeData({ commit }, payload) {
    const { partnerCode, type, divisionCode } = payload;
    let queryString = `incExc=${payload.incExc}&partnerGroupId=${payload.partnerGroupId}&schemePlanNo=${payload.schemePlanId}`;
    const url = URI.VALIDATE_PARTNER_EXCLUDE_INCLUDE_CODE_URL.replace(
      "{partnerCode}",
      partnerCode
    )
      .replace("{type}", type)
      .replace("{divisionCode}", divisionCode)
      .replace("{queryString}", queryString);

    const response = await BaseService.getSchemePlanningClient().put(
      url,
      payload.channelCode
    );
    return response.data.data;
  },
  async validatePartnerCodeData({ commit }, payload) {
    const { partnerCode, type, divisionCode } = payload;
    const url = URI.VALIDATE_PARTNER_CODE_URL.replace(
      "{partnerCode}",
      partnerCode
    )
      .replace("{type}", type)
      .replace("{divisionCode}", divisionCode);
    const response = await BaseService.getSchemePlanningClient().put(
      url,
      payload.channelCode
    );
    return response.data.data;
  },
  async validateTargetProductCodeData({ commit }, payload) {
    const url = URI.VALIDATE_TARGET_PARTNER_CODE_URL.replace(
      "{partnerCode}",
      payload.partnerCode
    ).replace("{targetNo}", payload.targetNo);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async validateProductExcludeIncludeCodeData({ commit }, payload) {
    const { productCode } = payload;
    let queryString = `incExc=${payload.incExc}&productGroupId=${payload.productGroupId}&schemePlanNo=${payload.schemePlanId}`;
    const url = URI.VALIDATE_PRODUCT_EXCLUDE_INCLUDE_CODE_URL.replace(
      "{productCode}",
      productCode
    ).replace("{queryString}", queryString);

    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async validateProductCodeData({ commit }, payload) {
    const url = URI.VALIDATE_PRODUCT_CODE_URL.replace(
      "{productCode}",
      payload.productCode
    );

    // const url = `/target/validate/partnerCode?partnerCode=${payload.productCode}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async saveUpdateExcludedUploadData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_UPDATED_PRODUCT_GROUP_URL,
      payload
    );
  },
  async saveSpecificProductGroupData({ commit }, payload) {
    // const url = `/productgroup/upload/product`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PRODUCT_GROUP_DATA_UPDATE_URL,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async updateLoader({ commit }, payload) {
    commit("setSchemeLoader", payload);
  },
  async fetchProductGroupMasterData({ commit }, payload) {
    // const url = `/productgroup/master`;
    const response = await BaseService.getSchemePlanningClient().get(
      URI.PRODUCT_GROUP_MASTER_URL
    );
    commit("setProductGroupMasterData", response.data.data);
  },
  async fetchProductlevelData({ commit }, payload) {
    // const url = `/productgroup/levels`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PRODUCT_GROUP_LEVELS_URL,
      payload
    );
    return response.data.data;
  },
  async getProdAttType({ commit }, payload) {
    const url = URI.PRODUCT_ATTRIBUTE_TYPE_URL.replace("{payload}", payload.val)
      .replace("{productOrgDimKey}", payload.productOrgDimKey)
      .replace("{levelNumber}", payload.levelNumber);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.dto
    );
    return response.data.data;
  },
  async productAttributeListAction({ commit }, payload) {
    const url = URI.PRODUCT_ATTRIBUTE_LIST_URL.replace("{payload}", payload.val)
      .replace("{productOrgDimKey}", payload.productOrgDimKey)
      .replace("{levelNumber}", payload.levelNumber)
      .replace("{name}", payload.name);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.dto
    );
    return response.data.data;
  },
  async downloadProductAttributeExportExcel({ commit }, payload) {
    const url = URI.DOWNLOAD_PRODUCT_ATTRIBUTE_EXPORT_EXCEL_URL
      .replace("{productOrgDimKey}", payload.productOrgDimKey)
      .replace("{levelNumber}", payload.levelNumber)
    let dto = {
      levelValIds: payload.levelValIds,
      attributeIDs: payload.attributeIDs
    }
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      dto,
      {
        responseType: "blob",
      }
    );
    return response;
  },
  async submitProductGroup({ commit }, payload) {
    // const url = `/productgroup/add`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_NEW_PRODUCT_GROUP_URL,
      payload
    );
    return response.data;
  },

  async saveGeneralData({ commit }, payload) {
    // const url = `/add`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_GENERAL_DATA_URL,
      payload
    );
    return response.data;
  },
  async updateGeneralData({ commit }, payload) {
    // const url = `/editPlan`;
    const response = await BaseService.getSchemePlanningClient().put(
      URI.EDIT_GENERAL_DATA_URL,
      payload
    );
    return response.data;
  },
  async updateSchemeStatus({ commit }, payload) {
    // const url = `/status/edit`;
    const data = {
      planId: payload.schemePlanNo,
      workflowStatus: payload.status,
    };
    const res = await BaseService.getSchemePlanningClient().patch(
      URI.UPDATED_SCHEMA_STATUS_URL,
      data
    );
    return res.data.data;
  },
  async getSelectedListAction({ commit }, payload) {
    let url = "";
    let queryString = `groupNo=${payload.groupNo}&masterFreezeDate=${payload.date}&sortBy=${payload.sort}&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&planNo=${payload.planNo}`;
    queryString +=
      payload.isPartner === "true"
        ? `&refresh=${payload.refreshData}&isDeleted=${payload.isDeleted}`
        : `&refreshData=${payload.refreshData}`;
    if (payload.isPartner === "true") {
      url = URI.SELECTED_PARTNER_GROUP_URL.replace(
        "{queryString}",
        queryString
      );
    } else {
      url = URI.SELECTED_PRODUCT_GROUP_URL.replace(
        "{queryString}",
        queryString
      );
    }
    const result = await BaseService.getSchemePlanningClient().get(url);
    commit("setSelectedPartnerDetails", result.data.data);
    return result.data;
  },
  async getSelectedListforMergeAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().put(
      URI.SIMULATE_CALL_PARTNER_FOR_MERGE_URL,
      payload
    );
    return response;
  },
  async uploadExcelUpdatedPartnerAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.UPLOAD_PARTNER_VIA_EXCEL_URL,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async uploadExcelUpdatedProductAction({ commit }, payload) {
    const url = URI.UPLOAD_PRODUCT_VIA_EXCEL_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async deletePartnerGroups({ commit }, payload) {
    // const url = `/partnergroup/delete`;
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_PARTNER_GROUP_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async deleteProductGroup({ commit }, payload) {
    // const url = `/productgroup/delete`;
    const result = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_PRODUCT_GROUP_URL,
      {
        data: payload,
      }
    );
    return result.data;
  },
  async getDetailSaveDraftAction({ commit }, payload) {
    let url =
      payload.isPartner === "true"
        ? URI.SAVE_PARTNER_AS_DRAFT_URL
        : URI.SAVE_UPDATED_PRODUCT_GROUP_URL;
    delete payload.isPartner;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async downloadPartnerDealerDetailsExcel({ commit }, payload) {
    let url = URI.DOWNLOAD_PARTNER_DEALER_DETAIL_URL.replace(
        "{planNumber}",
        payload.planNo
      ).replace("{partnerGroupNumber}", payload.partnerGroupNumber).replace("{exportPayoutOn}",payload.exportPayoutOn);
      let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async saveDraftAction({ commit }, payload) {
    // const url = `/add`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_GENERAL_DATA_URL,
      payload
    );
    return response.data;
  },
  async getProductAssociationData({ commit }, payload) {
    // const url = `/productgroup/link`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PRODUCT_ASSOCIATION_DATA_URL,
      payload
    );
    return response.data;
  },

  async getPartnerAssociationData({ commit }, payload) {
    // const url = `/partnergroup/planassociation`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PARTNER_ASSOCIATION_DATA_URL,
      payload
    );
    return response.data;
  },
  async getGeneralDataDetails({ commit }, payload) {
    const url = URI.GET_GENERAL_DATA_DETAILS.replace("{planId}", payload);
    const generalFormData = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setGeneralSectionData", generalFormData.data.data);
    return generalFormData.data.data;
  },
  async deletePartnerPlanAssociation({ commit }, payload) {
    const url = URI.DELETE_PARTNER_PLAN_ASSOCIATION_URL.replace(
      "{partnerGroupId}",
      payload.partnergroupId
    ).replace("{planId}", payload.planId);
    // const url = `/delete/planassociation?partnerGroupId=${payload.partnergroupId}&planId=${payload.planId}`;
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },

  async deleteProductPlanAssociation({ commit }, payload) {
    const url = URI.DELETE_PRODUCT_GROUP_ASSOCIATION_URL.replace(
      "{planId}",
      payload.planId
    ).replace("{groupId}", payload.groupId);
    // const url = `/productgroup/delete/planassociation?planId=${payload.planId}&groupId=${payload.groupId}`;
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },

  async getPartnerListingData({ commit }, payload) {
    const url = URI.PARTNERGROUP_ASSOCIATION_URL.replace(
      "{planId}",
      payload.planId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async getProductListingData({ commit }, payload) {
    const url = URI.PRODUCT_LISTING_URL.replace("{planId}", payload.planId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  // add program action

  async programMasterData({ commit }, payload) {
    const programs = await BaseService.getSchemePlanningClient().get(
      URI.PROGRAM_MASTER_DATA_URL
    );
    commit("setschemeProgramMasterData", programs.data.data);
    return programs.data;
  },
  async addProgrameData({ commit }, payload) {
    // const url = `/save/schemeprogram`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_SCHEMA_PROGRAM_URL,
      payload
    );
    return response.data;
  },
  async programListingData({ commit }, payload) {
    const url = URI.PROGRAM_LISTING_DATA_URL.replace("{payload}", payload);
    // const url = `/schemeprograms/${payload}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async deleteProgramAction({ commit }, payload) {
    // const url = `/delete`;
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_PROGRAM_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async copyProgramAction({ commit }, payload) {
    const url = URI.COPY_PROGRAM_URL.replace("{programNo}", payload.programNo);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async updateProgramAction({ commit }, payload) {
    // const url = `/update/schemeprogram`;
    const response = await BaseService.getSchemePlanningClient().put(
      URI.UPDATE_SCHEMA_PROGRAM_URL,
      payload
    );
    return response.data;
  },

  async updateSubCat({ commit }, payload) {
    commit("setbugetSubCatItem", payload);
  },
  async setpurposeSelec({ commit }, payload) {
    commit("setpurposeSelecItem", payload);
  },
  async setschemeFamilySelec({ commit }, payload) {
    commit("setschemeFamilySelecItem", payload);
  },
  async setpayoutOnSelec({ commit }, payload) {
    commit("setpayoutOnSelec", payload);
  },
  async eligibilityMasterDataAction({ commit }, payload) {
    const url = URI.ELIGIBILITY_MASTER_URL.replace(
      "{programNo}",
      payload.programNo
    );
    // const url = `/eligibility/master?programNo=${payload.programNo}`;
    const programs = await BaseService.getSchemePlanningClient().get(url);
    commit("setEligibilityMasterData", programs.data.data);
    return programs.data;
  },

  async targetMasterData({ commit }, payload) {
    const url = URI.TARGET_MASTER_URL.replace("{programNo}", payload.programNo);
    // const url = `/target/master?programNo=${payload.programNo}`;
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetMasterData", res.data.data);
    return res.data;
  },

  async systemTargetListingData({ commit }, payload) {
    const url = URI.SYSTEM_TARGET_LISTING_URL.replace("{programId}", payload);
    // const url = `/target/alltargets?programId=${payload}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async saveSystemTargetAction({ commit }, payload) {
    // const url = `/target/add`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_TARGET_SYSTEM_URL,
      payload
    );
    return response.data;
  },

  async deleteSystemTarget({ commit }, payload) {
    const url = URI.DELETE_SYSTEM_TARGET_URL.replace("{prgId}", payload.prgId);
    // const url = `/target/${payload.prgId}/delete`;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload.id,
    });
    return response.data;
  },

  async manualTargetListingData({ commit }, payload) {
    const url = URI.MANUAL_TARGET_LISTING_URL.replace(
      "{programNumber}",
      payload
    );
    // const url = `/target/getProgramTargetManualList?programNumber=${payload}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async getTargetLinkDataAction({ commit }, payload) {
    const url = URI.TARGET_LINK_DATA_URL.replace(
      "{programNo}",
      payload.programNo
    );
    // const url = `/target/targets/${payload.programNo}`;
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetLinkData", res.data.data);
  },

  async saveManualTargetAction({ commit }, payload) {
    const url = URI.SAVE_MANUAL_TARGET_URL.replace(
      "{programNumber}",
      payload.prgNo
    );
    // const url = `/target/addProgramTargetManual?programNumber=${payload.prgNo}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.payload
    );
    return response.data;
  },

  async updateTarget({ commit }, payload) {
    // const url = `/target/update`;
    const response = await BaseService.getSchemePlanningClient().put(
      URI.UPDATE_TARGET_URL,
      payload
    );
    return response.data;
  },

  async deleteManualTarget({ commit }, payload) {
    // const url = `/target/removeProgramTargetManualList`;
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_MANUAL_TARGET_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },

  async validationLinkData({ commit }, payload) {
    const url = URI.VALIDATE_LINK_DATA_URL.replace("{planNo}", payload.planNo);
    // const url = `/target/validations/${payload.planNo}`;
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setvalidationLinkData", res.data.data);
  },

  async saveConditionProgramData({ commit }, payload) {
    // const url = `/eligibility/add`;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.ADD_ELIGIBILITY_URL,
      payload
    );
    return response.data;
  },

  async updateConditionProgramData({ commit }, payload) {
    // const url = `/eligibility/update`;
    const response = await BaseService.getSchemePlanningClient().put(
      URI.UPDATE_ELIGIBILITY_URL,
      payload
    );
    return response.data;
  },

  async getViewTargetAction({ commit }, payload) {
    let url = URI.VIEW_TARGET_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{targetNo}", payload.targetNo);
    const target = await BaseService.getSchemePlanningClient().get(url);
    commit("setViewTarget", target.data.data);
    return target.data.data;
  },

  async saveTargetExceptionAction({ commit }, payload) {
    const url = URI.SAVE_TARGET_EXCEPTION_URL.replace("{id}", payload.id);
    // const url = `/target/save/finalTargets?targetNo=${payload.id}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data
    );
    return response.data;
  },

  async uploadTargetExceptionAction({ commit }, payload) {
    const url = URI.UPLOAD_TARGET_EXCEPTION_URL.replace(
      "{targetNo}",
      payload.targetNo
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  async updateTargetLine({ commit }, payload) {
    // const url = `/target/update`;
    const response = await BaseService.getSchemePlanningClient().put(
      URI.UPDATE_TARGET_URL,
      payload
    );
    return response.data;
  },

  // payout actions

  async getpayOutListingData({ commit }, payload) {
    const url = URI.PAYOUT_LISTING_URL.replace("{payload}", payload);
    // const url = `/payout/allpayout?programNo=${payload}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async payoutMasterData({ commit }, payload) {
    const url = URI.PAYOUT_MASTER_DATA_URL.replace(
      "{programNo}",
      payload.programNo
    );
    // const url = `/payout/master?programNo=${payload.programNo}`;
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setPayoutMasterData", res.data.data);
    return res.data;
  },
  async savePayoutDataAction({ commit }, payload) {
    const url = URI.PAYOUT_SAVE_URL.replace("{prgId}", payload.prgId);
    // const url = `/payout/save?programNo=${payload.prgId}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.item
    );
    return response;
  },
  async savePayoutCsv({ commit }, payload) {
    const url = URI.PAYOUT_SAVE_CSV_URL.replace("{payoutId}", payload.payoutId);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async saveBulkPayoutCsv({ commit }, payload) {
    const url = URI.PAYOUT_BULK_SAVE_CSV_URL.replace(
      "{programNo}",
      payload.programNo
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async editPayoutAction({ commit }, payload) {
    const url = URI.EDIT_PAYOUT_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async deletePayout({ commit }, payload) {
    const url = URI.DELETE_PAYOUT_URL.replace("{programNo}", payload.programNo);
    // const url = `/payout/${payload.programNo}/delete`;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload.data,
    });
    return response.data;
  },
  async fetchConditionEligListAction({ commit }, payload) {
    const url = URI.CONDITION_ELIGIBILITY_URL.replace(
      "{programNo}",
      payload.programNo
    );
    // let url = `/eligibility/viewall?programNo=${payload.programNo}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },

  async deleteConditionEligibity({ commit }, payload) {
    const url = URI.DELETE_CONDITION_ELIGIBILITY_URL.replace(
      "{programNo}",
      payload.programNo
    );
    // const url = `/eligibility/${payload.programNo}/delete`;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload.id,
    });
    return response.data;
  },

  async saveProgramTermAndCondition({ commit }, payload) {
    const url = URI.PROGRAM_TC_URL.replace("{programId}", payload.programId);
    // const url = `/schemeProgramTermAndCondition?programId=${payload.programId}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.dto
    );
    return response.data;
  },
  async fetchProgramTermAndCond({ commit }, payload) {
    const url = URI.PROGRAM_TC_URL.replace("{programId}", payload.programId);
    // let url = `/schemeProgramTermAndCondition?programId=${payload.programId}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },

  async getViewTemplateData({ commit }, payload) {
    const url = URI.VIEW_TEMPLATE_DATA_URL.replace("{id}", payload.id);
    // const url = `/payout/viewTempalte?programNo=${payload.id}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getParameterOptions({ commit }, payload) {
    // const url = `/getAdditionalParameter`;
    const response = await BaseService.getSchemePlanningClient().get(
      URI.PARAMETER_OPTIONS_URL
    );
    return response.data;
  },
  async saveValidationData({ commit }, payload) {
    const url = URI.SAVE_VALIDATION_DATA_URL.replace(
      "{planNumber}",
      payload.planNumber
    );
    // const url = `/saveValidation?planNumber=${payload.planNumber}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.validationList
    );
    return response.data;
  },
  async deleteValidationAPI({ commit }, payload) {
    const url = URI.DELETE_VALIDATION_URL;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async getValidationList({ commit }, payload) {
    const url = URI.VALIDATION_LIST_URL.replace("{payload}", payload);
    // const url = `/validationList?planNumber=${payload}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async saveSchemeTermAndCondition({ commit }, payload) {
    const url = URI.SAVE_SCHEME_TERM_CONDITION_URL.replace(
      "{planNumber}",
      payload.planNumber
    );
    // const url = `/schemePlanTermAndCondition?planNumber=${payload.planNumber}`;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.dto
    );
    return response.data;
  },
  async fetchSchemeTermAndCond({ commit }, payload) {
    const url = URI.SAVE_SCHEME_TERM_CONDITION_URL.replace(
      "{planNumber}",
      payload.planNumber
    );
    // let url = `/schemePlanTermAndCondition?planNumber=${payload.planNumber}`;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async copySchemePlan({ commit }, payload) {
    const url = URI.COPY_SCHEME_PLAN;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async payoutSlabSave({ commit }, payload) {
    const url = URI.SAVE_PAYOUT_SLAB_URL.replace(
      "{payoutId}",
      payload.payoutId
    ).replace("{eligibilityId}", payload.eligibilityId);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.dto
    );
    return response.data;
  },
  async downloadPayoutExcel({ commit }, payload) {
    let url = URI.PAYOUT_EXCEL_URL.replace(
      "{payoutNo}",
      payload.selectedPayoutId
    );
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async downloadBulkPayoutExcel({ commit }, payload) {
    let url = URI.PAYOUT_BULK_EXCEL_URL.replace(
      "{schemeProgramHdrId}",
      payload.schemeProgramHdrId
    );
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().post(
        url,
        payload.data,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().post(url,payload.data);
    }
    return response;
  },
  async downloadPrefillExcel({ commit }, payload) {
    let url = URI.PREFILL_EXCEL_URL.replace("{payoutId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadTargetExceptionExcel({ commit }, payload) {
    let url = URI.TARGET_EXCEPTION_URL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadUpdatedExcludePartnerUploadExcel({ commit }, payload) {
    let url = URI.EXCLUDE_DOWNLOAD_PARTNER_URL.replace(
        "{planNumber}",
        payload.planNumber
      ).replace("{partnerGroupNumber}", payload.partnerGroupNumber)
      .replace("{excFlag}", payload.excFlag);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadUpdatedExcludeProductUploadExcel({ commit }, payload) {
    let url = URI.EXCLUDE_DOWNLOAD_PRODUCT_URL.replace(
        "{planNumber}",
        payload.planNumber
      ).replace("{productGroupNumber}", payload.productGroupNumber)
      .replace("{excFlag}", payload.excFlag);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadSoldToPartnerExcel({ commit }) {
    let url = URI.SOLD_TO_PARTNER_URL;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadSpecificPartnerExcel({ commit }) {
    let url = URI.SPECIFIC_PARTNER_EXCEL_URL;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadSpecificProductExcel({ commit }) {
    let url = URI.SPECIFIC_PRODUCT_EXCEL_URL;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  setGeneralSectionData({ commit }, payload) {
    commit("setGeneralSectionData", payload);
  },
  async getMasterPartnerGeoElement({ commit }, payload) {
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.value}`)
      .join("&");
    const url = URI.PARTNER_MASTER_GEO_ELEMENT.replace(
      "{division}",
      payload.division
    ).replace("{channelIds}", channelIds);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setMasterPartnerGeo", response.data.data);
    return response.data.data;
  },
  async getMasterPartnerGeoLevel({ commit }, payload) {
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.value}`)
      .join("&");
    let levelId = `levelId=${payload.levelId}`;
    const url = URI.PARTNER_MASTER_GEO_LEVEL.replace(
      "{division}",
      payload.division
    )
      .replace("{channelIds}", channelIds)
      .replace("{levelId}", levelId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async getPartnerAttributeValue({ commit }, payload) {
    const url = URI.PARTNER_ATTRIBUTE_VALUE.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async reviseSchemePlan({ commit }, payload) {
    const url = URI.REVISE_SCHEME_PLAN.replace("{date}", payload.data.date)
    .replace(
      "{revisionId}",
      payload.revisionId
    );
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async revisePayout({ commit }, payload) {
    const url = URI.REVISE_PAYOUT_URL.replace(
      "{revisionId}",
      payload.revisionId
    );
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async deleteSchemePlanModal({ commit }, payload) {
    const url = URI.DELETE_SCHEME_PLAN_URL.replace("{planNo}", payload.planId);
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  setEligibilityRangeStartDate({ commit }, payload) {
    commit("setEligibilityRangeStartDate", payload);
  },
  async downloadLettterPreviewPdf({ commit }, payload) {
    let url = "";
    if (payload.partnerCodePreview) {
      url = `/scheme-planning/ims/preview/pdf/${payload.plan}?partnerCode=${payload.partnerCodePreview}`;
    } else {
      url = `/scheme-planning/ims/preview/pdf/${payload.plan}`;
    }
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  setSlabMinValue({ commit }, payload) {
    commit("setSlabMinValue", payload);
  },
  setBizSlabMinValue({ commit }, payload) {
    commit("setBizSlabMinValue", payload);
  },
  setDemoDeductionStartDateValue({ commit }, payload) {
    commit("setDemoDeductionStartDateValue", payload);
  },
  async getUpdatedExcludedListPartnerAction({ commit }, payload) {
    let url = "";
    let queryString = `partnerGroupNumber=${payload.partnerNumber}&planNo=${payload.planNo}&incExcFlg=${payload.incExcFlg}&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;
    url = URI.UPDATED_EXCLUDED_PARTNER_GROUP_URL.replace(
      "{queryString}",
      queryString
    );
    const result = await BaseService.getSchemePlanningClient().get(url);
    return result.data;
  },
  async getUpdatedExcludedListProductAction({ commit }, payload) {
    let url = "";
    let queryString = `PlanNumber=${payload.planNo}&productNumber=${payload.productNumber}&incExcFlg=${payload.incExcFlg}&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;
    url = URI.UPDATED_EXCLUDED_PRODUCT_GROUP_URL.replace(
      "{queryString}",
      queryString
    );
    const result = await BaseService.getSchemePlanningClient().get(url);
    return result.data;
  },
  setSchemeProgramData({ commit }, payload) {
    commit("setSchemeProgramData", payload);
  },
  async getTargetExceptionAction({ commit }, payload) {
    let url = URI.TARGET_EXCEPTION_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{schemeplantargetexcdeptionid}", payload.targetNo);
    const exception = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetException", exception.data.data);
    return exception.data.data;
  },
  async importPrefillCsvAction({ commit }, payload) {
    const url = URI.UPLOAD_PAYOUT_PREFILL_URL.replace(
      "{payoutId}",
      payload.payoutId
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async prefillSaveDraftAction({ commit }, payload) {
    const url = URI.PREFILL_SAVE_URL.replace("{payoutId}", payload.payoutId);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.productGroup
    );
    return response;
  },
  async getPrefillProductListingData({ commit }, payload) {
    const url = URI.PREFILL_PRODUCT_LIST_URL.replace("{payoutId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  updateSchemeExceptionSelectedPlans({ commit }, payload) {
    commit("setschemeExceptionSelectedPlans", payload);
  },
  setSelectedPlanListRows({ commit }, payload) {
    commit("setSelectedPlanListRows", payload);
  },
  async schemeExceptionApplyFilterAction({ commit }, payload) {
    let url = "";
    let pay = `exceptionId=${payload.exceptionType}&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
    url = URI.SCHEME_EXCEPTION_APPLY_FILTER.replace("{payload}", pay);
    const filterData = await BaseService.getSchemePlanningClient().get(url);
    return filterData.data;
  },
  async schemeExceptionMasterDropDownAction({ commit }, payload) {
    let url = URI.SCHEME_EXCEPTION_DROPDOWN_APPLY_ON.replace(
      "{schemePrgHdrId}",
      payload
    );
    const dropDownData = await BaseService.getSchemePlanningClient().get(url);
    commit("setSchemeExceptionMasterDropDown", dropDownData.data.data);
  },
  async schemeExceptionSaveAction({ commit }, payload) {
    let url = URI.SCHEME_EXCEPTION_SAVE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getReferenceAllProgramData({ commit }, payload) {
    const url = URI.SCHEME_REFERENCE_ALL_PROGRAM_LIST.replace(
      "{queryParams}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getReferencePayoutData({ commit }, payload) {
    const url = URI.SCHEME_REFERENCE_PAYOUT_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder)
    const response = await BaseService.getSchemePlanningClient().post(url,
      payload.programIds
    );
    return response.data;
  },
  async getExistingReferenceData({ commit }, payload) {
    const url = URI.SCHEME_REFERENCE_EXISTING_LIST.replace(
      "{programId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getExistingRefPayoutData({ commit }, payload) {
    const url = URI.SCHEME_REFERENCE_EXISTING_PAYOUT_LIST
    .replace("{currentPage}",payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder)
      .replace("{programId}", payload.programId);
    const response = await BaseService.getSchemePlanningClient().post(url, payload.schemeIds);
    return response.data;
  },
  async deleteExistingRef({ commit }, payload) {
    const url = URI.SCHEME_REFERENCE_EXISTING_DELETE.replace("{programId}", payload.programId)
    .replace("{deleteAll}", payload.deleteAll);
    const response = await BaseService.getSchemePlanningClient().delete(url, {data: payload.schemeId});
    return response.data;
  },
  async deleteExistingPayoutRef({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.SCHEME_REFERENCE_EXISTING_PAYOUT_DELETE,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async saveSchemeReferences({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SCHEME_REFERENCE_SAVE,
      payload
    );
    return response.data;
  },
  async getExistingExceptionAction({ commit }, payload) {
    const existingException = await BaseService.getSchemePlanningClient().put(
      URI.SCHEME_EXCEPTION_LIST,
      payload
    );
    return existingException.data.data;
  },
  async deleteSchemeExceptionAction({ commit }, payload) {
    const url = URI.SCHEME_EXCEPTION_DELETE;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload.id,
    });
    return response.data;
  },
  async executePlanProgram({ commit }, payload) {
    const url = URI.EXECUTE_PLAN_PROGRAM_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },

  async downloadSpecificModalExcel({ commit }) {
    let url = URI.SPECIFIC_MODAL_EXCEL_URL;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async saveSpecificModalGroupData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SPECIFIC_MODAL_ADD_URL,
      payload
    );
    return response.data;
  },
  async uploadSpecificModalData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SPECIFIC_MODAL_UPLOAD_URL,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async validateSpecificModalCodeData({ commit }, payload) {
    const url = URI.SPECIFIC_MODAL_VALIDATE_CODE_URL.replace(
      "{productCode}",
      payload.productCode
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async smartSearchSpecificModalCodeData({ commit }, payload) {
    let search = "";
    if (payload.type == "specific_modal") {
      search = `productLevel4Value=${payload.productCode}&divisionDimKey=${payload.divisionDimKey}`;
    } else {
      search = `productCode=${payload.productCode}&divisionDimKey=${payload.divisionDimKey}&incExc=${payload.incExc}&productGroup=${payload.productGroup}`;
    }
    const url = URI.SPECIFIC_MODAL_SMART_SEARCH_CODE_URL.replace(
      "{search}",
      search
    );

    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async smartSearchPartnerSpecificModalCodeData({ commit }, payload) {
    let search = "";
    if (payload.type == "partner_code") {
      let channels = payload.channels.map((obj) => `channels=${obj}`).join("&");
      search = `${payload.partnerCode}?division=${payload.division}&${channels}&typeId=${payload.typeId}`;
    } else if (payload.type == "partner_code_configruation") {
      let channels = payload.channels.map((obj) => `channels=${obj}`).join("&");
      search = `${payload.partnerCode}?division=${payload.division}&${channels}`;
    } else {
      search = `${payload.partnerCode}?division=${payload.division}&incExc=${payload.incExc}`;
    }
    const url = URI.PARTNER_SPECIFIC_MODAL_SMART_SEARCH_CODE_URL.replace(
      "{search}",
      search
    );

    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async smartSearchParentDealerCodeData({ commit }, payload) {
    const url = URI.PARTNER_PARENT_DEALER_SMART_SEARCH_CODE_URL.replace(
      "{search}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async simulateActionData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().put(
      URI.SIMULATE_CALL_URL,
      payload
    );
    return response;
  },
  async smartSearchPartnerCodeData({ commit }, payload) {
    const url = URI.PARTNER_CODE_SMART_SEARCH_CODE_URL.replace(
      "{search}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getProgramPartnerTypesListAction({ commit }, payload) {
    let url = "";
    let schemePrgHdrIds = payload.schemePrgHdrIds
      .map((obj) => `schemePrgHdrIds=${obj}`)
      .join("&");
    url = URI.PARTNER_TYPE_LIST.replace("{payload}", schemePrgHdrIds);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response;
  },
  async getSellerExclusionListAction({ commit }, payload) {
    let url = URI.GET_SELLER_EXCLUSION_LIST_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.schemePrgHdrIds
    );
    return response;
  },
  async getMarginExclusionListAction({ commit }, payload) {
    let url = URI.GET_MARGIN_EXCLUSION_LIST_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.schemePrgHdrIds
    );
    return response;
  },

  async getPartnerTypeFromList({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().get(
      URI.PARTNER_TYPE_FROM_LIST
    );
    commit("setPartnerTypeFromLists", response.data);
    return response;
  },
  async getPartnerCodeSellerExculsionList({ commit }, payload) {
    let url = URI.PARTNER_CODE_SELLER_EXCLUSION_LIST.replace(
      "{search}",
      payload.searchTerm
    ).replace(
      "{dealerFlag}",
      payload.dealerFlag
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setPartnerCodeLists", response.data);
    return response;
  },
  async getPartnerTypeToList({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PARTNER_TYPE_TO_LIST,
      payload
    );
    commit("setPartnerTypeToLists", response.data.data);
    return response;
  },
  async saveProgramPartnerTypes({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PARTNER_TYPE_SAVE,
      payload
    );
    return response;
  },
  async savePartnerCodeSellerExclusion({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SELLER_EXCLUSION_PARTNER_CODE_SAVE,
      payload
    );
    return response;
  },
  async saveMarginExclusion({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.MARGIN_EXCLUSION_PARTNER_CODE_SAVE,
      payload
    );
    return response;
  },

  async deleteProgramPartnerTypes({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.PARTNER_TYPE_DELETE,
      payload
    );
    return response;
  },
  async deletePartnerCodeSellerExclusion({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SELLER_EXCLUSION_PARTNER_CODE_DELETE,
      payload
    );
    return response;
  },
  async deleteMarginExclusion({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.MARGIN_EXCLUSION_PARTNER_CODE_DELETE,
      payload
    );
    return response;
  },

  async importCsvSellerExclusion({ commit }, payload) {
    let schemePrgHdrIds = payload.programHdrIds
      .map((obj) => `schemePrgHdrIds=${obj}`)
      .join("&");
    let url = URI.SELLER_EXCLSION_PARTNER_CODE_IMPORT.replace(
      "{requestParams}",
      schemePrgHdrIds
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async importCsvMarginExclusion({ commit }, payload) {
    let schemePrgHdrIds = payload.programHdrIds
      .map((obj) => `schemePrgHdrIds=${obj}`)
      .join("&");
    let url = URI.MARGIN_EXCLSION_PARTNER_CODE_IMPORT.replace(
      "{requestParams}",
      schemePrgHdrIds
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async exportSellerExculsionGrid({ commit }, payload) {
    let url = URI.SELLER_EXCLUSION_PARTNER_CODE_EXPORT;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.schemePrgHdrIds,
      {
        responseType: "blob",
      }
    );
    return response;
  },
  async exportMarginExclusionGrid({ commit }, payload) {
    let url = URI.MARGIN_EXCLUSION_PARTNER_CODE_EXPORT;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.schemePrgHdrIds,
      {
        responseType: "blob",
      }
    );
    return response;
  },
  async smartSearchPartnerAttributeCodeData({ commit }, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.value}`)
      .join("&");
    let pay = `${payload.groupType}?division=${payload.division}&${channelIds}&searchKey=${payload.search}`;
    url = URI.PARTNER_ATTRIBUTE_CODE_SMART_SEARCH_CODE_URL.replace(
      "{payload}",
      pay
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setGroupTypeDetails", response.data.data);
    return response.data;
  },
  async getOutLetMappingsOtionsActions({ commit }, payload) {
    let channelIds = payload.channelIds
      .map((obj) => `channels=${obj.value}`)
      .join("&");
    let requestParams = `divisionId=${payload.division}&${channelIds}&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
    let url = URI.GET_OUTLET_MAPPING_OPTIONS_URL.replace(
      "{requestParams}",
      requestParams
    );
    let response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async getDropDownOptionsAction({ commit }, payload) {
    let url = URI.GET_DEMO_DEDUCTION_DROPDOWN_OPTIONS_URL;
    let response = await BaseService.getSchemePlanningClient().get(url);
    commit("setDemoDeductionDropDownOptions", response.data.data);
    return response.data;
  },
  async getDemoDeductionListAction({ commit }, payload) {
    let url = URI.GET_DEMO_DEDUCTION_URL;
    let response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async deleteDemoDeductionAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.DEMO_DEDUCTION_DELETE_URL,
      payload
    );
    return response;
  },
  async saveDemoDeductionAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_DEMO_DEDUCTION_URL,
      payload
    );
    return response;
  },
  async releasePrograms({commit},payload){
    const response = await BaseService.getSchemePlanningClient().post(
      URI.RELEASE_PROGRAMS_URL,
      payload
    );
    return response;
  },
  async getretailVisibilityListAction({ commit }, payload) {
    let url = URI.GET_RETAIL_VISIBILITY_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder)
    let response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.payoutId
    );
    return response.data;
  },
  async deleteRetailVisibilityAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.DELETE_RETAIL_VISIBILITY_URL,
      payload
    );
    return response;
  },
  async saveRetailVisibilityAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_RETAIL_VISIBILITY_URL,
      payload
    );
    return response;
  },
  async importCsvRetailVisibility({ commit }, payload) {
    let programPayoutIds = payload.programPayoutIds
      .map((obj) => `prgPayoutIds=${obj}`)
      .join("&");
    let url = URI.IMPORT_RETAIL_VISIBILITY_URL.replace(
      "{requestParams}",
      programPayoutIds
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async exportRetailVisibilityGrid({ commit }, payload) {
    let url = URI.EXPORT_RETAIL_VISIBILITY_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.programPayoutIds,
      {
        responseType: "blob",
      }
    );
    return response;
  },
  async calculateTargetAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.CALCULATE_TARGET,
      payload
    );
    return response;
  },
  async storeConditionEligibityAction({ commit }, payload) {
    commit("setStoreConditionEligibity", payload);
  },
  async smartSearchSKUCode({ commit }, payload) {
    const url = URI.SKU_CODE_SMART_SEARCH_URL.replace(
      "{division}",
      payload.division
    ).replace(
      "{skuCode}",
      payload.skuCode
    );

    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async isAddModifyAddProgramAction({commit}, payload) {
    commit('setIsAddModifyAddProgram', payload)
  },
  async downloadAddProgramExcel({ commit }, payload) {
    let url = URI.ADD_PROGRAM_EXPORT.replace("{programHdr}", payload.programId).replace("{withData}", payload.withData);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async uploaddAddProgramExcel({ commit }, payload) {
    const url = URI.UPLOAD_ADD_PROGRAM_URL.replace(
      "{programHdr}",
      payload.programNo
    )
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async getAddProgramManualUploadStatusAction({ commit }, payload) {
    let url = URI.GET_ADD_PROGRAM_MANUAL_UPLOAD_STATUS
    .replace("{schemePlanNo}", payload);
    let response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async getAddProgramManualUploadErrorfileDownloadAction({ commit }, payload) {
    let url = URI.ADD_PROGRAM_MANUAL_UPLOAD_ERROR_FILE_DOWNLOAD
      .replace("{programHdr}", payload.programHdr)
      .replace("{manualUploadHdrId}", payload.manualUploadHdrId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadSchemePlanExcel({ commit }, payload) {
    let url = URI.PLAN_LIST_DOWNLOAD.replace(
      "{startDate}",
      payload.startDate
    ).replace(
      "{endDate}",
      payload.endDate
    );
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().post(url, payload.headers, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().post(url, payload.headers);
    }
    return response;
  },
  async nerpIsReadyForNerpAction({ commit }, payload) {
    const url = URI.NERP_IS_READY_FOR_NERP
      .replace("{programId}", payload.programId)
      .replace("{readyForNerp}", payload.readyForNerp);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
    );
    return response.data.data;
  },
  async bulkNerpIsReadyForNerpFromSchmePlanAction({ commit }, payload) {
    const url = URI.BULK_NERP_IS_READY_FOR_NERP_FROM_SCHEME_PLAN
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data.data;
  },
  async storeAddProgramForReportPayoutAction({ commit }, payload) {
    commit("setStoreAddProgramForReportPayout", payload);
  },
  async schemesPlanForMergeDropDownAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().get(URI.PLAN_FOR_MERGE);
    return response.data;
  },
  async viewAllMergePlanAction({commit}, payload) {
    const url = URI.VIEW_ALL_MERGE_PLAN_LIST
    .replace('{planNo}', payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setViewAllMergePlanAction", response.data.data);
    return response.data;
  },
  async reviseMergePlanAction({commit}, payload) {
    const url = URI.REVISE_MERGE_PLAN
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async getBranchEmailAttachmentUploadAction({ commit }, payload) {
    const url = URI.BRANCH_EMAIL_ATTACHMENT_UPLOAD_URL.replace(
      "{planNumber}",
      payload.planNo
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.file,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async getBranchEmailDataDetails({ commit }, payload) {
    const url = URI.BRANCH_EMAIL_ATTACHMENT_URL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async downloadBranchEmailAttachmentExcel({ commit }, payload) {
    const url = URI.BRANCH_EMAIL_ATTACHMENT_EXPORT_FILE_URL.replace(
      "{fileId}",
      payload.fileId
    ).replace("{planNo}", payload.planNo);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async deleteBranchEmailAttachment({ commit }, payload) {
    const url = URI.BRANCH_DELETE_SCHEDULE_ATTACHMENT_URL.replace(
      "{payload}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async importProductAttributeMasterAction({ commit }, form) {
    let url = URI.PRODUCT_ATTIBUTE_ADD_IMPORT_MASTER;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async deletePartnerProductUpdateExcludeMaster({ commit }, payload) {
    let url = ""
    if(payload.type == "partner"){
      url = URI.DELETE_PARTNER_UPDATE_EXCLUDE_MASTER
      .replace("{type}",payload.type)
      .replace("{flag}",payload.tabType);
    }else{
      url = URI.DELETE_PRODUCT_UPDATE_EXCLUDE_MASTER
      .replace("{type}",payload.type)
      .replace("{flag}",payload.tabType);
    }
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data
    );
    return response.data;
  },
  async partnerTypeAttributeForPartnerAttributeAction({commit}, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.text}`)
      .join("&");
    let pay = `divisionCode=${payload.divisionCode}&${channelIds}`;
    url = URI.PARTNER_TYPE_ATTRIBUTE_FOR_PARTNER_ATTRIBUTE.replace("{payload}", pay);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async partnerCodeAttributeForPartnerAttributeAction({commit}, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.text}`)
      .join("&");
    let partnerTypes = payload.partnerTypes
      .map((obj) => `partnerTypes=${obj.text}`)
      .join("&");
    let pay = `${partnerTypes}&divisionCode=${payload.divisionCode}&${channelIds}&searchKey=${payload.searchTerm}`;
    url = URI.PARTNER_CODE_ATTRIBUTE_FOR_PARTNER_ATTRIBUTE.replace("{payload}", pay);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async downloadExcelPayoutAttributeAction({ commit }, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelIds=${obj.text}`)
      .join("&");
    let partnerTypes = payload.partnerTypes
      .map((obj) => `partnerTypes=${obj.text}`)
      .join("&");
    let pay = `withData=${payload.withData}&${partnerTypes}&divisionCode=${payload.divisionCode}&${channelIds}`;
    url = URI.EXCEL_PARTNER_ATTRIBUTE_DOWNLOAD.replace("{payload}", pay);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async partnerTypeAttribureExcel({ commit }, payload) {
    let url = "";
    let channelIds = payload.channelIds
      .map((obj) => `channelCodes=${obj.text}`)
      .join("&");
    let partnerTypes = payload.partnerTypes
      .map((obj) => `partnerTypeList=${obj.text}`)
      .join("&");
    let pay = `${partnerTypes}&divisionCode=${payload.divisionCode}&${channelIds}`;
    url = URI.PARTNER_TYPE_ATTIBUTE_EXCEL.replace("{payload}", pay);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async partnerTypeAttributeListViewAllAction({ commit }, payload) {
    let url = URI.PARTNER_ATTRIBUTE_LIST_PARTNER_TYPE.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder)
      .replace("{partnerGroupId}", payload.partnerGroupId);
    const schemes = await BaseService.getSchemePlanningClient().get(url);
    return schemes.data.data;
  },
  async nerpCampaignMasterAction({ commit }, payload) {
    let url = URI.NERP_CAMPAIGN_MASTER_GER
      .replace("{master}", payload.master)
      .replace("{productType}", payload.productType)
      .replace("{productCategory}", payload.productCategory)
      .replace("{schemeFamily}", payload.schemeFamily)
      .replace("{schemeNature}", payload.schemeNature)
      .replace("{purposeType}", payload.purposeType);
    const schemes = await BaseService.getSchemePlanningClient().get(url);
    commit("setnerpCampaignMaster", schemes.data);
    return schemes.data;
  },
  async validateProgramsForPayoutCommunicationAction({ commit }, payload) {
    let url = URI.VALIDATE_PROGRAM_FOR_PAYOUT_COMMUNICATION
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async holdSignleSelectSchedulePayoutComm({commit}, payload) {
    commit("setHoldSignleSelectSchedulePayoutComm", payload)
  },
  async savePartialSchmeAction({ commit }, payload) {
    let url = URI.SAVE_PARTIAL_SCHEME
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
};

export default action;
